import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/png/epoukaz-tablet.png")